import React from 'react';
import BaseSkeleton from './BaseSkeleton';

const SurveyCardSkeleton = () => {
    return (
        <div className="bg-white rounded-xl border border-gray-200 p-4 h-full flex flex-col">
            <div className="flex-1 mb-5 space-y-3">
                <BaseSkeleton className="h-5 w-4/5" />
                <BaseSkeleton className="h-4 w-full" />
                <BaseSkeleton className="h-4 w-2/3" />
            </div>
            <div className="mt-auto">
                <BaseSkeleton className="h-12 w-full rounded-lg" />
            </div>
        </div>
    );
};

export default SurveyCardSkeleton;